<template>
    <v-layout row wrap justify-center>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <!-- Header -->
        <v-flex xs12 sm12 md12 lg12 xl12>
        </v-flex>
        
        <!-- Content -->
        <v-flex xs12 sm12 md7 lg7 xl7>
            <v-card
                shaped
                elevation=3
                class="pa-2"
                >
                <v-card-title class="d-flex d-sm-none subtitle-1 font-weight-bold">Pesquisa Treinamento TReports</v-card-title>
                <v-card-title class="d-none d-sm-flex title">Pesquisa Treinamento TReports</v-card-title>
                <v-divider class="mx-4 mb-4"></v-divider>
                <v-card-text v-show="!answered">
                    <v-form
                        ref="form"
                        v-model="valid"
                        lazy-validation>

                        <v-text-field
                        v-model="email"
                        label="E-mail"
                        :rules="emailRules"
                        dense
                        disabled
                        required
                        ></v-text-field>

                        <v-card-text class="pa-0 ma-0 my-2 font-weight-bold">
                            Qual sua relação com o Protheus?
                        </v-card-text>
                        <v-radio-group v-model="profession" :mandatory="false">
                            <v-radio label="Sou usuário do sistema. Na empresa em que trabalho usamos o Protheus" value="Sou usuário do sistema. Na empresa em que trabalho usamos o Protheus"></v-radio>
                            <v-radio label="Sou TI e dou suporte a usuários que usam Protheus" value="Sou TI e dou suporte a usuários que usam Protheus"></v-radio>
                            <v-radio label="Sou Analista e implanto o Prothues nas empresas" value="Sou Analista e implanto o Prothues nas empresas"></v-radio>
                            <v-radio label="Sou Programador e quero aprender mais sobre Protheus" value="Sou Programador e quero aprender mais sobre Protheus"></v-radio>
                        </v-radio-group>
                
                        <v-card-text class="pa-0 ma-0 my-2 font-weight-bold">
                            Você já tentou montar relatórios pra Protheus em ADVPL, SigaRPM ou qualquer outra ferramenta?
                        </v-card-text>
                        <v-textarea
                        v-model="question1"
                        dense
                        outlined
                        rounded
                        
                        required
                        ></v-textarea>

                        <v-card-text class="pa-0 ma-0 my-2 font-weight-bold">
                            Qual foi a sua maior dificuldade pra conseguir fazer os relatórios?
                        </v-card-text>
                        <v-textarea
                        v-model="question2"
                        label=""
                        dense
                        outlined
                        rounded
                        
                        required
                        ></v-textarea>
                        
                        <v-card-text class="pa-0 ma-0 my-2 font-weight-bold">
                            Se você pudesse fazer um teinamento de TReports, o que não poderia faltar nesse treinamento?
                        </v-card-text>
                        <v-textarea
                        v-model="question3"
                        dense
                        outlined
                        rounded
                        required
                        ></v-textarea>
                        
                        <v-card-text class="pa-0 ma-0 my-2 font-weight-bold">
                            Se vc pudesse fazer qualquer pergunta sobre confecção de relatórios pra Protheus com o TReports, o que você perguntaria?
                        </v-card-text>
                        <v-textarea
                        v-model="question4"
                        dense
                        outlined
                        rounded
                        
                        required
                        ></v-textarea>  

                        <v-btn
                            :disabled="!valid"
                            color="success"
                            class="mr-4"
                            @click="validate"
                        >
                        Enviar
                        </v-btn>              

                    </v-form>
                </v-card-text>
                <v-card-text v-show="answered" class="title text-center font-weight-black grey--text text--darken-3">
                    Em nome da equipe Userfunction, muito obrigado por nos ajudar :)
                </v-card-text>
            </v-card>
        </v-flex>
        
        <!-- Footer -->
        <v-flex xs12 sm12 md12 lg12 xl12>
        </v-flex>        
    </v-layout>
</template>

<script>
import { baseApiUrl, cloneDeep, showSuccess, showError } from '@/global'
import axios from 'axios'

export default {
    name: 'formTReports',
    components: {  },
    data: function() {
        return {
            overlay: false,
            answered: false,
            valid: true,
            email: '',
            emailRules: [
                v => !!v || 'E-mail é obrigatório',
                v => /.+@.+\..+/.test(v) || 'E-mail inválido',
            ],
            profession: '',
            professionRules: [
                v => !!v || 'Profissão é obrigatória',
            ],
            question1: '',
            question2: '',
            question3: '',
            question4: '',
        }
    },
    methods: {
        validate () {
            this.overlay = true
            if (this.$refs.form.validate()) {
                this.snackbar = true
                
                if (this.profession === '') {
                    showError('Por favor informe qual sua relação com o Protheus!')
                    this.overlay = false
                } else if (
                    this.question1 === '' &&
                    this.question2 === '' &&
                    this.question3 === '' &&
                    this.question4 === ''
                ) {
                    showError('Por favor responder pelo menos uma das questões!')
                    this.overlay = false
                } else {
                    const url = `${baseApiUrl}/researches/treports`
                    const payload = {
                        email: this.email,
                        profession: this.profession,
                        question1: this.question1,
                        question2: this.question2,
                        question3: this.question3,
                        question4: this.question4,
                    }
                    axios.post(url, payload)
                        .then(async res => {
                            if (res.status === 200) {
                                this.$refs.form.reset()
                                this.answered = true
                                this.overlay = false
                            }
                        })
                        .catch((error) => {
                            this.overlay = false
                            showError(error)
                        })
                }
            } else {
                this.overlay = false
                showError('Existem erros no formulário, favor conferir!')
            }
        },
    },
    created() {
        this.email = this.$route.query.email
    }
}
</script>

<style>
    /* .v-toolbar, .v-navigation-drawer { display: none!important; }
    .v-content { 
        padding-top: 0!important; 
        padding-left: 0!important; 
    }
    .v-footer { 
        left: 0!important; 
    } */
</style>
